import { cn } from "@newxsystems/shared";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaRichText } from "../../../../modules/content/components/WohaRichText/WohaRichText";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;
  const effectiveColumns = Math.min(columnCount || 3, items.length) as 1 | 2 | 3 | 4;

  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-12">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid gap-4", columns[effectiveColumns])}>
          {items.map((item, index) => (
            <article className="rounded-xl border border-ash bg-white p-6 md:p-7" key={index}>
              <p className="font-satoshi text-5xl font-medium leading-none tracking-[-0.035em] text-charcoal text-balance md:text-6xl">
                {item.value}
              </p>
              <h3 className="mt-4 text-base font-semibold text-charcoal">{item.label}</h3>
              {item.description ? (
                <WohaRichText
                  className="mt-2 max-w-[32ch] text-sm leading-6 text-steel"
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </WohaSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
